import { render, staticRenderFns } from "./legalSubject.vue?vue&type=template&id=c067f48a&scoped=true&"
import script from "./legalSubject.vue?vue&type=script&lang=js&"
export * from "./legalSubject.vue?vue&type=script&lang=js&"
import style0 from "./legalSubject.vue?vue&type=style&index=0&id=c067f48a&prod&scoped=true&lang=css&"
import style1 from "./legalSubject.vue?vue&type=style&index=1&id=c067f48a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c067f48a",
  null
  
)

export default component.exports